/* eslint-disable @nx/enforce-module-boundaries */
import { Link, Tab, HStack, Tabs } from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { JobsListingContext } from '../context';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const TrackApplicationTabs = forwardRef(({ active, ...props }, ref) => {
  const { t } = useTranslator();
  const {
    appliedJobsListing,
    refetchAppliedJobsListing,
    appliedJobsListingHasNextPage,
    fetchAppliedJobsListingNextPage,
    appliedJobsListingIsFetching,
    appliedJobsListingIsLoading,
  } = useContext(JobsListingContext);

  const pendinglisting =
    appliedJobsListing?.filter?.((aj) => aj.status === 'APPLIED') ?? [];
    const inReviewListing =
    appliedJobsListing?.filter?.((aj) => aj.status === 'SHORTLISTED' || aj.status === 'OFFERED') ?? [];
    const declinedListing =
    appliedJobsListing?.filter?.((aj) => aj.status === 'REJECTED') ?? [];


  return (
    <Tabs defaultIndex={active} {...props}  w="100%" mb="2%">
      <HStack>
        <Link as={Tab} display={pendinglisting?.length > 0 ? "block" : "block"} href="/jobs/my/track/pending" fontSize={["14px",'16px']}>
          {t('jobs.pendingReview') || "Pending Review"} {pendinglisting?.length ? `(${pendinglisting?.length})` : null}
        </Link>
        <Link as={Tab} display={inReviewListing?.length > 0 ? "block" : "block"} href="/jobs/my/track/in-review" fontSize={["14px",'16px']}>
          {t('jobs.inReview') || "In Review"} {inReviewListing?.length ? `(${inReviewListing?.length})` : null}
        </Link>
        <Link as={Tab} display={declinedListing?.length > 0 ? "block" : "block"} href="/jobs/my/track/declined" fontSize={["14px",'16px']}>
          {t('jobs.declined') || "Declined"} {declinedListing?.length ? `(${declinedListing?.length})` : null}
        </Link>
      </HStack>
    </Tabs>
  );
});
